import { useSelector } from 'react-redux'
import { token, userId, userInfo } from './selectors'

export const useToken = () => useSelector(token)
export const useUserInfo = () => useSelector(userInfo)
export const useUserId = () => useSelector(userId)
